import { Navigate, Outlet } from 'react-router-dom'

import { Spinner } from '../../ui/Spinner/Spinner'
import { canManageOrganization } from '../settings/settings-access'
import { useOrganizationAdmin } from './useOrganizationAdmin'

/**
 * The `/organization/*` pages: Owners and Admins only, from the
 * server-verified organization answer. Anyone else (and any refused or
 * unreadable answer) lands on their own clinic Settings.
 */
export function OrganizationAdminRoute() {
  const organization = useOrganizationAdmin()

  if (organization.isPending) {
    return <Spinner label="Checking organization access" />
  }
  if (!canManageOrganization(organization.data)) {
    return <Navigate to="/settings" replace />
  }
  return <Outlet />
}
